var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/** @jsx jsx */


import { jsx } from '@emotion/core';
import { Button } from '../../Button';
import { Popover } from '../../Popover';
import { itemStyles } from './item';

var ActionButton = function ActionButton(_a) {
  var appearance = _a.appearance,
      icon = _a.icon,
      onClick = _a.onClick,
      text = _a.text,
      disabled = _a.disabled,
      loading = _a.loading;
  return jsx(Button, {
    appearance: appearance || 'secondary',
    size: "small",
    onClick: onClick,
    icon: icon,
    disabled: disabled,
    loading: loading
  }, text);
};

export var ActionArea = function ActionArea(_a) {
  var popover = _a.popover,
      action = __rest(_a, ["popover"]);

  return jsx("div", {
    css: itemStyles
  }, popover ? jsx(Popover, {
    content: popover,
    placement: "bottomRight"
  }, jsx("div", null, jsx(ActionButton, __assign({}, action)))) : jsx(ActionButton, __assign({}, action)));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/actionArea.js
// module id = 960
// module chunks = 0